<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Logging') }}</h1>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                    <router-link
                        class="btn btn-gray shadow-sm rounded"
                        to="/workspace/admin/settings"
                    >
                        {{ $t('Back') }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6">
                <loading :status="loading"/>
                <form @submit.prevent="save">
                    <div class="shadow sm:rounded sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white sm:p-6">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="sentry_dsn">{{ $t('Sentry DSN') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="sentry_dsn"
                                            v-model="sentry_dsn"
                                            :placeholder="$t('Sentry DSN')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            type="text"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 py-3 stage-footer-surface text-right sm:px-6">
                            <div class="inline-flex">
                                <button class="btn btn-green rounded shadow-sm" type="submit">
                                    {{ $t('Save settings') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "logging",
    data() {
        return {
            loading: true,
            sentry_dsn: null,
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            const self = this;
            axios.get('api/workspace/admin/settings/logging').then(function (response) {
                self.sentry_dsn = response.data.sentry_dsn;
                self.loading = false;
            }).catch(function () {
                this.$router.push('/workspace/admin/settings');
            });
        },
        save() {
            const self = this;
            self.loading = true;
            axios.post('api/workspace/admin/settings/logging', {
                sentry_dsn: self.sentry_dsn
            }).then(function () {
                self.loading = false;
                self.$store.commit('patchSettings', {
                    sentry_dsn: self.sentry_dsn,
                });
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Settings updated successfully').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
